module.exports = __webpack_public_path__ + "static/media/selflove.c748e0ba.jpeg";